<!--充值明细-->
<template>
  <div class="home-main agent">
    <div class="main">
      <div class="main_title">
        <span class="title-cn">伙伴账户余额表</span>
        <span class="title-en">/Account Balance</span>
      </div>
      <!--筛选部分start-->
      <div class="agent-selector">
        <div class="select-item">
          <p>归属维护人</p>
          <el-input v-model="searchOption.staff_name" class="select-input" size="small" clearable></el-input>
        </div>
        <div class="select-item">
          <p>伙伴名称</p>
          <el-input v-model="searchOption.name" class="select-input" size="small" clearable></el-input>
        </div>
        <div class="select-item">
          <p>伙伴用户名</p>
          <el-input v-model="searchOption.username" class="select-input" size="small" clearable></el-input>
        </div>
        <el-button size="small" class="warning" @click="search">搜索</el-button>
        <el-button size="small" @click="restSearch">重置</el-button>
      </div>
      <!--筛选部分end-->

      <div class="agent-main-line"></div>

      <!--订单列表start-->
      <div class="agent-main-list">
        <el-table height="100%" :data="tableData" style="width: 100%" stripe>
          <el-table-column width="40"> </el-table-column>
          <el-table-column label="归属维护人">
            <template slot-scope="scope">
              <span>{{ scope.row.staff_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="伙伴名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="伙伴用户名">
            <template slot-scope="scope">
              <span>{{ scope.row.username }}</span>
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <span>{{ pointType[scope.row.type] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="当前可用余额">
            <template slot-scope="scope">
              <span>{{ scope.row.point }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--订单列表end-->


    </div>
  </div>
</template>

<script>
  import { createGetUrlParams } from "@/utils/url";
  import { adminFinanceList } from "@/api/agent";
  export default {
    data() {
      return {
        pagination: {
          use: true,
          total: 0,
          size: 20,
          currentPage: 1,
        },
        /*筛选条件-充值时间start*/
        searchOption: {
          staff_name: "",
          name: "",
          username: "",
        },
        /*表格数据start*/
        tableData: [],
        /*表格数据end*/
        formLabelWidth: "110px",

        /*权限开通start*/
        offlineVisable: false,
        offlineForm: {
          code: "",
          auth_code: ""
        },
        offlineFormRules: {
          code: [
          {
            required: true,
            message: "请输入machineid",
            trigger: "blur",
          }, ],
          auth_code: [
          {
            required: true,
            message: "请输入授权码",
            trigger: "blur",
          }, ],
        },
        pointType:{
            2:"通用币",
            1:"FastBI产品专用币",
            3:"安捷云产品专用币",
            4:"小智产品专用币",
        }
      };
    },
    mounted() {
      this.getTransactionData();
    },
    methods: {


      // handleCurrentChange(val) {
      //   this.pagination.currentPage = val;
      //   this.getTransactionData();
      // },
      // handleSizeChange(val) {
      //   if (val <= this.pagination.total) {
      //     this.pagination.size = val;
      //     this.getTransactionData();
      //   }
      // },
      getTransactionData() {
        this.loading = true;
        let params = {
          p: this.pagination.currentPage,
          count: 100000,

        };
        let result = createGetUrlParams(params);
        if (result.success) {
          this.getData(result.data)
        }
      },
      balanceData(staff_name, name, username, type, point) {
        return {
          staff_name,
          name,
          username,
          type,
          point
        }
      },
      getData(data) {
        adminFinanceList(data)
          .then((response) => {
            console.log(response);
            this.loading = false;
            let data = []
            response.results.forEach(item => {
              const { username, staff_name, name, finance } = item
              if (finance) {
                data.push(this.balanceData(staff_name, name, username, 2, finance.point),this.balanceData(staff_name, name, username, 1, finance.fbi_point),this.balanceData(staff_name, name, username, 3, finance.af_point),this.balanceData(staff_name, name, username, 4, finance.xz_point));
              } else {
                data.push(this.balanceData(staff_name, name, username, 2, 0),this.balanceData(staff_name, name, username, 1, 0), this.balanceData(staff_name, name, username, 3, 0),this.balanceData(staff_name, name, username, 4, 0));
              }
            });
            this.tableData = data;
          })
          .catch((err) => {
            this.loading = false;
          });
      },
      search() {
        this.restPage(true);
        let params = {
          staff_name: this.searchOption.staff_name,
          name: this.searchOption.name,
          username: this.searchOption.username
        };
        let result = createGetUrlParams(params);

        if (result.success) {
          this.loading = true;
          this.getData(result.data)
        }
      },
      restPage(isUsePagination) {
        this.pagination.use = isUsePagination;
        this.pagination.currentPage = 1;
        this.pagination.size = 20;
      },
      restSearch() {
        for (const key in this.searchOption) {
          if (this.searchOption.hasOwnProperty(key)) {
            this.searchOption[key] = "";
          }
        }
        this.restPage(true);
        this.getTransactionData();
      },
    },
  };
</script>

<style lang="scss">
  @import url("../../assets/css/system.css");

  .agent {
    .main {
      display: flex;
      flex-direction: column;
      margin: 0px 14px;
      height: 100%;
      //background-color: #FFFFFF;
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;

      .main_title {
        margin: 15px 0;
      }

      .product-selector {
        height: 37px !important;
        background: #fff;

        .selector-center {
          margin-left: 0 !important;
          width: 400px !important;
        }
      }

      .group {
        p {
          margin: 10px 15px 10px 5px !important;
          float: left !important;
          width: 80px !important;
          height: 32px !important;
          line-height: 32px !important;
          text-align: right !important;
        }
      }

      .group .el-input {
        float: left !important;
        margin: 10px 0px !important;
        width: 200px !important;
      }

      .product-main-list {
        flex-grow: 1;
        height: 50%;
      }

      .selector-right {
        height: 100% !important;
        line-height: 50px !important;
      }
    }
  }

  /*筛选部分start*/
  .agent-selector {
    padding: 18px 0px 20px 24px !important;
    min-width: 980px !important;
    font-size: 12px !important;
    height: 32px !important;
    background: #fff;
  }

  .select-item {
    float: left;
    margin-right: 34px;

    .el-select {
      width: auto;
    }
  }

  .select-item .el-date-editor {
    width: 180px;
  }

  .select-item .el-input__inner {
    padding-right: 0px;
  }

  .select-item p {
    padding-right: 10px;
    float: left;
    height: 32px;
    line-height: 32px;
    text-align: right;
  }

  .select-input {
    float: left;
    width: 180px;
  }

  .selcet-product .el-input__inner {
    width: 150px;
    height: 32px;
    line-height: 32px;
  }

  .el-select-dropdown__list {
    padding: 6px 0px 22px 0px;
  }

  .el-select-dropdown span {
    font-size: 12px;
  }

  /*筛选部分end*/

  .agent-main-line {
    width: 100%;
    border-bottom: 1px solid #ededed;
  }

  /*订单列表start*/
  .agent-main-list {
    min-width: 1100px;
    flex-grow: 1;
    height: 50%;
    /*margin-top: 10px;*/
    /*margin:35px 30px 0px 30px;*/
  }

  .agent-main-list .cell span {
    font-size: 12px;
  }

  /*订单列表end*/
  .account-table {
    .el-input__inner {
      height: 30px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/system/accountBalance.vue